import {
  Pipe,
  PipeTransform
} from '@angular/core';

@Pipe({ name: 'dateTime' })
export class DateTimePipe implements PipeTransform {
  transform(value: number): string {
    if (value === 0) {
      return '';
    }
    const date = new Date(value);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString().slice(0,5);
  }
}
